module.exports = __webpack_public_path__ + "static/media/VN.a195eaf1.png";